import React, { useState, useEffect } from "react";
import { UnoStoreHooks } from "@simulanisindia/ui";
import RoleHeader from "./RoleHeader";
import RolesList from "./RolesList";
import { checkPermissionExist } from "../../utils/general";
import { ROLES_VIEW_PERMISSION } from "../../constant/permission";
import { useNavigate } from "react-router-dom";

const { useUnoSelector } = UnoStoreHooks;

const RoleManagement = ({ isMobileView }) => {
  const navigate = useNavigate();
  const userData = useUnoSelector((state) => state.user);

  useEffect(() => {
    if (!checkPermissionExist(ROLES_VIEW_PERMISSION)) {
      navigate(`dashboard/${userData.user.uuid}`);
    }
  }, []);
  const [showBackBtn, setShowBackBtn] = useState(true);
  
  return (
    <>
      <div className="role-page">

        <RoleHeader isMobileView={isMobileView} showBackBtn={showBackBtn} roleheader={true} />

        <div className="role-card mobilerolelist">
          <div className="role-header">
            <div className="role-info">
              <h5>User Roles</h5>
              <p>
                User Roles can be assigned to the employees from here, New roles can created and privileges for all
                these roles can be managed from this section.
              </p>
            </div>
          </div>
          <div className="role-table">
            <RolesList isMobileView={isMobileView} />
          </div>
        </div>

      </div>
    </>
  );
};

export default RoleManagement;
